import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { likeMix, unlikeMix } from '../redux/thunk/likedMixesThunk';
import PillFace from './PillFace';

const MixLikeButton = ({ mix, prominent = false }) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const likedMixSet = useSelector(state => state.likedMixes.likedMixSet);
    // .pop = confirmation beat on a user-initiated like (prominent-pill CSS).
    const [pop, setPop] = useState(false);

    const djName = mix.djName || mix.artist;
    const key = mix.title && djName ? `${mix.title}|||${djName}` : null;
    const isLiked = key ? likedMixSet[key] : false;

    const handleClick = useCallback((e) => {
        e.stopPropagation();
        if (!isAuthenticated || !key) return;
        if (isLiked) {
            setPop(false);
            dispatch(unlikeMix({ title: mix.title, djName }));
        } else {
            setPop(true);
            dispatch(likeMix(mix));
        }
    }, [dispatch, isAuthenticated, isLiked, key, mix, djName]);

    if (!isAuthenticated || !mix.title) return null;

    const heart = (
        <svg width="13" height="13" viewBox="0 0 24 24" fill={isLiked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
    );

    return (
        <button
            className={`track-like-btn${prominent ? ' prominent' : ''}${isLiked ? ' liked' : ''}${pop ? ' pop' : ''}`}
            title={isLiked ? 'Unlike mix' : 'Like mix'}
            onClick={handleClick}
            onAnimationEnd={(e) => { if (e.animationName === 'pill-pop') setPop(false); }}
        >
            {prominent ? <PillFace icon={heart} label={isLiked ? 'Liked' : 'Like'} longest="Liked" /> : heart}
        </button>
    );
};

export default MixLikeButton;
